import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import {
  CompanyData,
  ProfileData
} from "../../components/Profile/types/profileTypes";

export interface ProfileState {
  profileData?: ProfileData;
  companyData?: CompanyData;
}

export const initialProfileState: ProfileState = {};

export const profileSlice = createSlice({
  name: "profileSlice",
  initialState: initialProfileState,
  reducers: {
    setProfileData: (state, action: PayloadAction<ProfileData>) => {
      state.profileData = { ...action.payload };
    },
    resetProfileData: (state) => {
      state.profileData = initialProfileState.profileData;
    },
    setCompanyData: (state, action: PayloadAction<CompanyData>) => {
      state.companyData = { ...action.payload };
    },
    resetCompanyData: (state) => {
      state.companyData = initialProfileState.companyData;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setProfileData,
  resetProfileData,
  setCompanyData,
  resetCompanyData
} = profileSlice.actions;

export default profileSlice.reducer;
